import {
  Stack,
  useTheme,
  Typography,
  IconButton,
  AccordionSummary,
} from "@mui/material";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";

import type { PaymentPlansType } from "@/types";

interface PaymentPlanItemProps {
  paymentPlan: PaymentPlansType;
}

export function PaymentPlanItem({ paymentPlan }: PaymentPlanItemProps) {
  const { breakpoints } = useTheme();
  const fontSize = breakpoints.down(490) ? "0.875rem" : "1rem";
  return (
    <AccordionSummary
      expandIcon={
        <IconButton>
          <MdOutlineKeyboardArrowDown />
        </IconButton>
      }
      aria-controls="panel1a-content"
      id="panel1a-header"
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Stack
        width={"100%"}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        {paymentPlan?.title ? (
          <Typography
            color="text.secondary"
            fontWeight={600}
            fontSize={fontSize}
          >
            {paymentPlan.title}
          </Typography>
        ) : null}
      </Stack>
    </AccordionSummary>
  );
}
